
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import AdminLayout from "@/components/admin/AdminLayout";
import { useAdminCheck } from "@/hooks/useAdminCheck";
import { useToolUsageStats } from "@/hooks/useToolUsageStats";
import AvailableToolsList from "@/components/admin/tools/AvailableToolsList";
import ToolUsageInstructions from "@/components/admin/tools/ToolUsageInstructions";
import ToolAnalyticsTable from "@/components/admin/tools/ToolAnalyticsTable";

const ToolsManagement = () => {
  const { isLoading: isAuthLoading } = useAdminCheck();
  const { isLoading: isStatsLoading, toolUsageStats } = useToolUsageStats();

  const isLoading = isAuthLoading || isStatsLoading;

  return (
    <AdminLayout 
      title="Tools Management" 
      backLink="/admin/dashboard" 
      backLabel="Back to Dashboard"
    >
      <div className="mb-6">
        <h1 className="text-2xl font-bold mb-2">Interactive Tools Management</h1>
        <p className="text-gray-500">
          Configure and manage interactive tools that can be embedded in blog posts.
        </p>
      </div>

      <Tabs defaultValue="overview">
        <TabsList className="mb-4">
          <TabsTrigger value="overview">Overview</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>
        
        <TabsContent value="overview" className="space-y-6">
          <AvailableToolsList 
            toolUsageStats={toolUsageStats} 
            isLoading={isLoading} 
          />
          <ToolUsageInstructions />
        </TabsContent>
        
        <TabsContent value="analytics" className="space-y-6">
          <Card>
            <CardHeader>
              <CardTitle>Tool Usage Analytics</CardTitle>
              <CardDescription>
                Insights into how your interactive tools are being used
              </CardDescription>
            </CardHeader>
            <CardContent>
              <ToolAnalyticsTable 
                stats={toolUsageStats} 
                isLoading={isLoading} 
              />
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </AdminLayout>
  );
};

export default ToolsManagement;
